<template>

</template>

<script>
    export default {
        created() {
            this.$router.replace({name: this.$route.params.url, params: {key: this.$route.params.key}});
        }
    }
</script>

<style scoped>

</style>
